import { useEffect, useState, useRef } from "react";
import { InputGroup } from "react-bootstrap";
import Select from "react-select";
import uuid from "react-uuid";
import { AutoComplete, Simplebar, SvgComponent } from "components";
import { GridView } from "components/GridView/GridView";
import IconButton from "components/IconButton/IconButton";
import ToolTip from "components/ToolTip/ToolTip";
import { AnimatedIconButton } from "components/AnimatedIconButton/AnimatedIconButton";
import { DateTimePicker } from "components/DateTimePicker/DateTimePicker";
import useExceptionHandler from "hooks/useExceptionHandler";
import usePaginationValuesWhere from "hooks/usePaginationValuesWhere";
import { DateHelper, DEFAULT_PAGINATION_VALUES } from "utils";
import { TransaccionesManager } from "managers";
import {
  eCF
}
  from "models/ECF/ECF";

import "../Lookup.style.scss";
import {
  buttonStyle,
  controlsProportion,
  initialWhere,
  initialWhereModal,
} from "..";

export const TransaccionesLookup = ({
  initialValue = { label: "", value: "" },
  onChange,
  isDisabled,
  isInput = false,
}) => {
  const ref = useRef(null);
  const { handleException } = useExceptionHandler();
  const { setPaginationValuesWhere } = usePaginationValuesWhere();
  const [showCanvas, setShowCanvas] = useState(false);
  const [modalList, setModalList] = useState([]);
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION_VALUES);
  const [dateFilterkey, setDateFilterKey] = useState(uuid());
  const [fechaCreacionFilterkey, setFechaCreacionFilterKey] = useState(uuid());

  const [whereModal, setWhereModal] = useState({
    ...initialWhereModal,
    Estatus: "",
    EstadoECFList: "A,C",
  });

  const [selectedValue, setSelectedValue] = useState({
    label: "",
    value: "",
  });

  const ESTATUS_COMPROBANTE_ACEPTADOS_LIST = [{ value: "", label: "Todos" }, ...eCF.ESTATUS_COMPROBANTE_ACEPTADOS];

  useEffect(() => {
    if (whereModal !== initialWhereModal) {
      buscar();
    }
  }, [whereModal]);

  useEffect(() => {
    if (
      selectedValue != undefined &&
      selectedValue.value !== null &&
      selectedValue.value != ""
    ) {
      onChange(selectedValue);
    }
  }, [selectedValue]);

  useEffect(() => {
    if (
      initialValue.value &&
      initialValue.value != "" &&
      initialValue.value !== selectedValue.value &&
      initialValue.value !== -1
    ) {
      setValue();
    }
    if (initialValue.value === -1) {
      setSelectedValue({
        label: "",
        value: "",
      });
    }
  }, [initialValue.value]);

  const setValue = () => {
    TransaccionesManager.buscarPorId(initialValue.value, true).then(
      (data) => {
        setSelectedValue(data);
      }
    );
  };

  function buscar() {
    const whereWithPaginationValues = {
      ...whereModal,
      ...pagination,
    };
    TransaccionesManager.listado(whereWithPaginationValues)
      .then((res) => {
        setPaginationValuesWhere(res.Headers, pagination, setPagination);
        const transformedList = res.Data.map(transaccion => {
          const transaccionFormateada = { ...transaccion };
          if (transaccion.Fecha) {
            transaccionFormateada.Fecha = DateHelper.formatStringDate(transaccion.Fecha, false);
          }
          if (transaccion.FechaCreacion) {
            transaccionFormateada.FechaCreacion = DateHelper.formatStringDate(transaccion.FechaCreacion, true);
          }
          return transaccionFormateada;
        });

        setModalList(transformedList);
      })
      .catch((err) => handleException(err));
  }

  const handleCerrar = () => {
    setShowCanvas(false);
  };

  const onPageIndexChanging = (pageNumber) => {
    setPagination((prevstate) => {
      return { ...prevstate, IndiceDePagina: pageNumber - 1 };
    });
    setWhereModal({ ...whereModal });
  };

  const getSuggestions = async (value) => {
    const inputValue = typeof value === "string" && value ? value.trim().toLowerCase() : "";
    const res = await TransaccionesManager.listado({
      ...initialWhere,
      ENCF: inputValue,
      Estatus: "",
    });
    const safeList = res.Data.map(transaccion => ({
      ...transaccion,
      label: typeof transaccion.ENCF === "string" ? transaccion.ENCF : "",
      value: transaccion.IdSec ?? "",
    }));
    return safeList;
  };

  const onReset = () => {
    setDateFilterKey(uuid());
    setFechaCreacionFilterKey(uuid());
  };

  return (
    <>
      <InputGroup>
        <div style={{ display: 'none' }}>
          <AutoComplete
            getList={getSuggestions}
            parentValue={selectedValue}
            setParentValue={setSelectedValue}
            noBorderRadius={isInput}
            isDisabled={isDisabled}
          />
        </div>
        <InputGroup.Append style={{ width: controlsProportion.button }}>
          <AnimatedIconButton
            size="40px"
            height="18"
            width="18"
            message={"Seleccionar Transacciones Disponibles"}
            style={buttonStyle}
            disabled={isDisabled}
            iconName="search"
            onClick={() => {
              setShowCanvas(true);
              setTimeout(() => {
                buscar();
              }, 200);
            }}
          />
        </InputGroup.Append>
      </InputGroup>
      {showCanvas && (
        <Simplebar
          ref={ref}
          backdrop={true}
          placement={"end"}
          portal={false}
          size="lg"
          useLoading={false}
          visible={showCanvas}
          setShow={(e) => setShowCanvas(e)}
          title={"Seleccionar Transacciones Disponibles"}
          btnLeft={{
            show: false,
            func: () => { },
          }}
          btnRight={{
            show: false,
            func: () => { },
          }}
        >
          <GridView
            pagination={pagination}
            setPagination={setPagination}
            allowPaging={pagination.EsPaginable}
            pageSize={pagination.CantidadPorPagina}
            pageIndex={pagination.IndiceDePagina}
            lastPageNumber={pagination.PaginasTotal}
            dataSource={modalList}
            onPageIndexChanging={onPageIndexChanging}
            where={whereModal}
            setWhere={setWhereModal}
            onReset={onReset}
          >
            <GridView.Column
              bodyRenderer={(row) => {
                return (
                  <div className="float-right">
                    <IconButton
                      onClick={() => {
                        setSelectedValue({
                          value: row.IdSec,
                          label: row.ENCF,
                          ENCF: row.ENCF,
                          Fecha: row.Fecha,
                        });
                        handleCerrar();
                      }}
                    >
                      <ToolTip message="Seleccionar">
                        <div>
                          <SvgComponent
                            height="20"
                            width="20"
                            iconName="check"
                          />
                        </div>
                      </ToolTip>
                    </IconButton>
                  </div>
                );
              }}
            />
            <GridView.Column
              headerText="Id"
              dataField="IdSec"
              sortExpression="IdSec"
              width="75px"
            />
            <GridView.Column
              date
              hideFilter
              headerText="Fecha"
              dataField="Fecha"
              sortExpression="FechaEmision"
              width="225px"
              filterRenderer={(onInputChange) => {
                return (
                  <DateTimePicker
                    key={dateFilterkey}
                    soloFecha
                    esRangoFechas
                    esGrid
                    usarLabel={false}
                    fechaInicioOriginal={whereModal?.RangoFechas?.fechaInicio || ""}
                    fechaFinOriginal={whereModal?.RangoFechas?.fechaFin || ""}
                    onChange={(e) =>
                      onInputChange({
                        target: { name: "RangoFechas", value: e },
                      })
                    }
                  />
                );
              }}
            />
            <GridView.Column
              headerText="E-CF"
              dataField="ENCF"
              sortExpression="eNCF"
              width="175px"
            />
            <GridView.Column
              headerText="Id Interno"
              dataField="NumeroFacturaInterna"
              sortExpression="NumeroFacturaInterna"
              width="150px"
            />
            <GridView.Column
              headerText="Estado e-CF"
              dataField="EstadoECF"
              sortExpression="EstadoECF"
              width="180px"
              filterRenderer={() => {
                return (
                  <Select
                    className="react-select primary"
                    options={ESTATUS_COMPROBANTE_ACEPTADOS_LIST}
                    value={ESTATUS_COMPROBANTE_ACEPTADOS_LIST.filter(function (option) {
                      return (
                        option.value === (whereModal.EstadoECF ?? ESTATUS_COMPROBANTE_ACEPTADOS_LIST[0].value)
                      );
                    })}
                    name="EstadoECF"
                    onChange={(e) => {
                      if (e.value === ESTATUS_COMPROBANTE_ACEPTADOS_LIST[0].value) {
                        setWhereModal({
                          ...whereModal,
                          EstadoECFList: "A,C",
                          EstadoECF: e.value
                        });
                      }
                      else {
                        setWhereModal({
                          ...whereModal,
                          EstadoECF: e.value
                        });
                      }
                    }}
                  />
                );
              }}
            />
            <GridView.Column
              headerText="RNC Comprador"
              dataField="RNCComprador"
              sortExpression="RNCComprador"
              width="175px"
            />
            <GridView.Column
              headerText="Monto Total"
              dataField="MontoTotal"
              sortExpression="MontoTotal"
              width="150px"
              number={true}
            />
            <GridView.Column
              date
              hideFilter
              headerText="Fecha Creacion"
              dataField="FechaCreacion"
              sortExpression="FechaCreacion"
              width="225px"
              filterRenderer={(onInputChange) => {
                return (
                  <DateTimePicker
                    key={fechaCreacionFilterkey}
                    soloFecha
                    esRangoFechas
                    esGrid
                    usarLabel={false}
                    fechaInicioOriginal={
                      whereModal?.RangoFechasCreacion?.fechaInicio || ""
                    }
                    fechaFinOriginal={whereModal?.RangoFechasCreacion?.fechaFin || ""}
                    onChange={(e) =>
                      onInputChange({
                        target: { name: "RangoFechasCreacion", value: e },
                      })
                    }
                  />
                );
              }}
            />
          </GridView>
        </Simplebar>
      )}
    </>
  );
};